__turbopack_context__.v({
  "errorMessage": "feedbackPage-module-scss-module__LOVY-G__errorMessage",
  "form": "feedbackPage-module-scss-module__LOVY-G__form",
  "formActions": "feedbackPage-module-scss-module__LOVY-G__formActions",
  "formInputs": "feedbackPage-module-scss-module__LOVY-G__formInputs",
  "formRow": "feedbackPage-module-scss-module__LOVY-G__formRow",
  "formTitle": "feedbackPage-module-scss-module__LOVY-G__formTitle",
  "intro": "feedbackPage-module-scss-module__LOVY-G__intro",
  "introBanner": "feedbackPage-module-scss-module__LOVY-G__introBanner",
  "introText": "feedbackPage-module-scss-module__LOVY-G__introText",
  "successContainer": "feedbackPage-module-scss-module__LOVY-G__successContainer",
  "successMessage": "feedbackPage-module-scss-module__LOVY-G__successMessage",
});
